import React from "react";
import imagee from "../../../images/placeholder.png";

const ExerciseSelectionModal = ({
  excercisemodal,
  setExcerciseModal,
  workoutExercise,
  addExcercises,
  excerciseList,
  keyword,
  setkeyword,
  toggleExercise,
  isSelectedExercise,
}) => {
  if (!excercisemodal) return null;

  return (
    <div className="excercise-modal excerciseul">
      <div className="child-modal">
        <div className="add-excersie">
          <button
            className="button"
            onClick={() => addExcercises(workoutExercise)}
          >
            Add excercises
          </button>
          <i
            className="fa fa-times"
            onClick={() => setExcerciseModal(false)}
          ></i>
        </div>
        <ul className="filtered-excercises">
          {workoutExercise?.exercises?.map((exercise, index) => (
            <li key={index}>{exercise?.exercise?.name}</li>
          ))}
        </ul>

        <ul className="excercise-list">
          <li>
            <div className="form-group mb-4">
              <input
                type="text"
                placeholder="search exercise"
                className="form-control input"
                value={keyword}
                onChange={(e) => setkeyword(e.target.value)}
              />
            </div>
          </li>
          {excerciseList?.map((item) => (
            <li
              key={item.id}
              onClick={() => toggleExercise(item)}
              className={`exercise-item ${
                isSelectedExercise(item.id) ? "selectedex" : ""
              }`}
            >
              <div className="leftt">
                <img src={imagee} alt="" />
                <div>
                  <p className="name">{item?.name}</p>
                  <p className="value">
                    {item?.input?.map((value, ind) => (
                      <span key={ind}>{value?.field_name},</span>
                    ))}
                  </p>
                </div>
              </div>
              {item?.video !== null && (
                <a className="video" href={item?.video} target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-video"></i>
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ExerciseSelectionModal;
